
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/strategy/ri5",
      function () {
        return require("private-next-pages/strategy/ri5.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/strategy/ri5"])
      });
    }
  